/**
 * Store dedicado al manejo de tabla.
 *
 * @namespace tachnical_support
 */

import { getPaginatedItems } from "@/utils";
import { PAGINATION_DEFAULT } from "@/const";
import api from "../../api";

const state = {
  status: "",
  originalItems: [], // lista original de datos sin paginar
  items: [], // lista de datos paginada
  pagination: PAGINATION_DEFAULT,
  url: undefined,
  params: {},
  instances: {}
};

const getters = {
  isLoading: (state) => state.status === "loading",
  getItems2: (state) => state.items,
  hidePaginator: (state) => state.pagination.total <= 10,
  getItem:
    (state) =>
    ({ key, item }) => {
      const keym = key === undefined ? "Id" : key;

      if (item[key] === undefined) return {};
      return state.items.find((f) => f[keym] === item[keym]);
    }
};

const actions = {
  resetCurrent: ({ commit }) => {
    commit("pagination", {
      pageSize: state.pagination.pageSize,
      currentPage: 1,
      total: state.pagination.total,
      skip: state.pagination.skip
    });
  },
  /**
   * Buscar los items desde la api, se debe setear el state url,
   * si se requiere el uso de params para la peticion, se puede
   * setear directo en state o se puede pasar directo a esta accion.
   *
   * @name getItems
   * @param {String} url - Url usado para la peticion.
   * @param {Number} current_page - Pagina a la cual se quiere navegar.
   * @param {Number} page_size - Cantidad de linea por pagina.
   * @param {Object} params - Parametros pasados a la peticion.
   */
  getItems: (
    { dispatch, state, commit, rootState },
    { url, current_page, page_size, params, paginateFromApi }
  ) => {
    return new Promise((resolve, reject) => {
      // commit("items", []);
      commit("loading");

      let paginateFromApi2 = paginateFromApi ?? true;
      const current = current_page ?? state.pagination.currentPage;
      const size = page_size ?? state.pagination.pageSize;
      const skip = state.pagination.skip;

      if (url && typeof url === "string") {
        commit("url", url);
      }

      // TODO: Realmente es necesario ?, esto provoca que se le pase params de consultas cruzadas.
      if (params !== undefined && typeof params === "object") {
        commit("params", params);
      } else {
        commit("params", {});
      }

      const p = {
        page: current,
        skipItems: skip,
        skip: skip,
        limit: size,
        companyId: rootState.user.user.CompanySelected,
        ...state.params
      };

      api
        .get(state.url, {
          timeout: 3 * 60 * 1000,
          params: p
        })
        .then((resp) => {
          commit("success");

          if (
            typeof resp.data === "object" &&
            resp.data["Items"] !== undefined
          ) {
            commit("items", resp.data.Items);
            commit("originalItems", resp.data.Items);
          } else {
            // INFO: Si no es Items, quiere decir que debemos paginar
            // del lado del cliente
            commit("items", resp.data);
            commit("originalItems", resp.data);
          }

          if (paginateFromApi2 === true) {
            commit("pagination", {
              currentPage: resp.data.CurrentPage,
              total: resp.data.ItemCount,
              skip: resp.data.Skip,
              pageSize: size
            });
          } else {
            dispatch("paginate", {});
          }
          resolve(resp);
        })
        .catch((err) => {
          commit("items", []);
          commit("error");
          reject(err);
        });
    });
  },
  /**
   * Esta accion pagina items del lado del frontend.
   * Importante: si quieres invocar esto sin parametros, se debe
   * pasar un {Object} vacio.
   *
   * @name paginate
   * @param {Number} current_page - Pagina a la cual se quiere navegar.
   * @param {Number} page_size - Cantidad de linea por pagina.
   */
  paginate: ({ state, commit }, { current_page, page_size }) => {
    commit("loading");

    const skip = state.pagination.skip;
    const current =
      current_page === undefined ? state.pagination.currentPage : current_page;
    const size = page_size ?? state.pagination.pageSize;
    const { page, pageSize, total /*, pageSizes*/, data } = getPaginatedItems(
      state.originalItems,
      current,
      size
    );

    commit("items", data);
    commit("pagination", {
      currentPage: page,
      pageSize: pageSize,
      total,
      // pageSizes: pageSizes,
      skip
    });
    commit("success");
  },
  getIndex: ({ state }, { filtered }) => {
    const items = state.items;
    const index = items.findIndex(filtered);
    return index;
  }
};

const mutations = {
  loading: (state) => {
    state.status = "loading";
  },
  success: (state) => {
    state.status = "success";
  },
  error: (state) => {
    state.status = "error";
  },
  items: (state, data) => {
    state.items = data;
  },
  originalItems: (state, data) => {
    state.originalItems = data;
  },
  pagination: (state, pagination) => {
    state.pagination = pagination;
  },
  url: (state, url) => {
    state.url = url;
  },
  changePageSize: (state, pageSize) => {
    state.pagination = {
      pageSize: pageSize,
      ...state.pagination
    };
  },
  changeCurrentPage: (state, currentPage) => {
    state.pagination = {
      currentPage: currentPage,
      ...state.pagination
    };
  },
  params: (state, params) => {
    state.params = params;
  },
  removeItem: (state, indexItem) => {
    state.items.splice(indexItem, 1);
  },
  pushItem: (state, item) => {
    state.items.push(item);
    // state.originalItems.push(item);
  },
  updateItem: (state, payload) => {
    const index = state.items.findIndex((l) => l.Id === payload.Id);
    state.items.splice(index, 1, payload.item);

    // const index2 = state.originalItems.findIndex(l => l.Id === payload.Id);
    // state.originalItems.splice(index2, 1, payload.item);
  },
  UPDATE_ITEM: (state, { key, item }) => {
    const itemm = JSON.parse(JSON.stringify(item));
    const keym = key === undefined ? "Id" : key;

    if (itemm[key] === undefined) return;
    const index = state.items.findIndex((f) => f[keym] === itemm[keym]);

    state.items.splice(index, 1, itemm);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
